import { render } from "./AppLayout.vue?vue&type=template&id=76921d66"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__